<template>
  <v-container
    id="view-endpoint-list"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <Breadcrumb :items="items" ></Breadcrumb>

        <h1>
          Downloads Available
        </h1>

      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="downloads"
            :search="search"
            item-key="id"
            :items-per-page=100
            class="elevation-1"
          >
            <template #item.is_downloaded="{ value, item }">
              <v-chip
                v-if="!value && item.file_size"
                color="#5cbbf6"
                dark
                small
              >
                New
              </v-chip>
            </template>
            <template #item.file_state="{ value }">
              <v-chip
                v-if="value === 'in_progress'"
                color="#5cbbf6"
                dark
                small
              >
                In Progress
              </v-chip>
              <v-chip
                v-else-if="value === 'success'"
                color="green"
                dark
                small
              >
                Available
              </v-chip>
            </template>
            <template #item.id="{ value, item }">
              <v-btn
                v-if="item.file_state === 'success'"
                x-small
                :loading="downloadLoading"
                :disabled="downloadLoading"
                color="blue-grey"
                class="ma-2 white--text"
                fab
                @click="downloadFile(item.id, item.name)"
              >
                <v-icon dark>
                  mdi-cloud-download
                </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {get} from "vuex-pathify";
import Breadcrumb from "@/components/Breadcrumb";
import {fileDownload} from "@/mixins/file-download";

export default {
  name: "DownloadList",
  metaInfo () {
    return {
      title: "Downloads"
    }
  },
  components: {
    Breadcrumb
  },
  mixins: [ fileDownload ],
  data: () => ({
    loaded: false,
    downloadLoading: false,
    search: '',
    headers: [
      {text: "", align: 'start', value: 'is_downloaded'},
      {text: "Status", value: 'file_state'},
      {text: "Request Type", value: 'type'},
      {text: 'Reference', value: 'reference'},
      {text: 'Requested At', value: 'created_at'},
      {text: 'File Size', value: 'file_size'},
      {text: '', value: 'id'}
    ],
  }),
  computed: {
    downloads: get('downloads/downloads'),
    items() {
      return [
        {
          text: 'All Downloads',
          disabled: true,
        }
      ];
    }
  },
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", {title: "Loading Downloads"});

      if (!this.downloads.length) {
        await this.$store.dispatch("downloads/getDownloadList", { force: true });
      }

      await this.$store.dispatch("loader/loaderCancel");

      this.loaded = true;
    },
    async downloadFile(fileRef, name) {
      this.downloadLoading = true;

      const url = "downloads/download-file/" + fileRef;
      const result = await this.triggerFileDownload(url, name);

      if (result) {
        await this.$store.dispatch("downloads/getDownloadList", { force: true });
      }

      this.downloadLoading = false;
    }
  }
}
</script>

<style scoped>

</style>
